import React, { useEffect, useState } from "react";
import HelpHyperLink from "../../../unicomponents/HelpHyperLink";
import DropdownSchoolYear from "../../../unicomponents/Dropdowns/DropdownSchoolYear";
import { useUIContext } from "../../../context/UIContext";
import useVariousStudentRecords from "../../../hooks/useVariousStudentRecords";
import { generateRegistrationRows } from "../../../util/dealingArrObj";
import DropdownHierarchyOne from "../../../unicomponents/Dropdowns/DropdownHierarchyOne";
import DropdownHierarchyTwo from "../../../unicomponents/Dropdowns/DropdownHierarchyTwo";
import DropdownHierarchyThree from "../../../unicomponents/Dropdowns/DropdownHierarchyThree";
import DropdownUniqueUsersInDisplayData from "../../../unicomponents/Dropdowns/DropdownUniqueUsersInDisplayData";
import useRegistrationInfo from "../../../hooks/useRegistrationInfo";
import { useAuthContext } from "../../../context/AuthContext";
import { checkHrteachers } from "../../../util/checkPermissions";
import SimpleAlertMessageBlock from "../../../unicomponents/SimpleAlertMessageBlock";
import { useTranslation } from "react-i18next";

export default function SepumReadingRecord({
  settingData,
  inputData,
  schoolId,
  inputQueryConditions,
  hrTeachersData,
}) {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    schoolYear: null,
    schoolYearId: "",
    hierarchyOneId: "",
    hierarchyTwoId: "",
    hierarchyThreeId: "",
    organPathForSort: "N/A",
    selectedStudent: "",
  });

  const [queryConditions, setQueryConditions] = useState({
    schoolid: schoolId,
    school_year_id: "",
    record_list_id: inputQueryConditions?.record_list_id,
  });

  const [readingRows, setReadingRows] = useState({
    1: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
    2: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
    3: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
    4: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
    5: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
    total: { sumBooks: "", distance: "", sumBooksEng: "", points: "" },
  });

  const [studentList, setStudentList] = useState([]);
  const [validateInput, setValidateInput] = useState({});
  const [dataToSave, setDataToSave] = useState([]);
  const [isModified, setIsModified] = useState(false);

  const {
    registrationInfoQuery: { data: registrationInfoData },
  } = useRegistrationInfo({ schoolid: schoolId });

  const { getVariousStudentDataWithRegi, createOrUpdateVariousStudentRecords } =
    useVariousStudentRecords(queryConditions);

  const { setIsLoadingModal, handleToastCenterTop } = useUIContext();
  const { hasPermission } = useAuthContext();

  useEffect(() => {
    let initialSchoolYear = null;
    let initialSchoolYearId = null;

    if (
      filters.schoolYear === null &&
      registrationInfoData &&
      settingData &&
      settingData.length > 0
    ) {
      const initialData = settingData.sort(
        (a, b) => b.school_year - a.school_year
      )[0];

      initialSchoolYear = initialData.school_year;
      initialSchoolYearId = initialData.id;
      setFilters((filters) => ({
        ...filters,
        schoolYear: initialSchoolYear,
        schoolYearId: initialSchoolYearId,
      }));

      setQueryConditions((prev) => ({
        ...prev,
        school_year_id: initialSchoolYearId,
        school_year: initialSchoolYear,
      }));

      if (initialSchoolYear) {
        const sortedRows = generateRegistrationRows(
          registrationInfoData,
          settingData,
          initialSchoolYear,
          filters.organPathForSort
        );
        setStudentList(sortedRows);
      }
    } else {
      if (registrationInfoData && settingData) {
        const sortedRows = generateRegistrationRows(
          registrationInfoData,
          settingData,
          filters.schoolYear,
          filters.organPathForSort
        );
        setStudentList(sortedRows);
      }
    }
  }, [
    filters,
    filters.organPathForSort,
    filters.schoolYear,
    registrationInfoData,
    settingData,
  ]);

  useEffect(() => {
    if (hrTeachersData && filters.schoolYear)
      if (checkHrteachers(hrTeachersData, "", filters.schoolYear)) {
        const thisYearData = hrTeachersData.filter(
          (r) => r.schoolYear === filters.schoolYear
        );
        const splited = thisYearData[0].organization_path.split("/");

        setFilters((filters) => ({
          ...filters,
          hierarchyOneId: splited[2],
          hierarchyTwoId: splited[3],
          hierarchyThreeId: splited[4],
          organPathForSort: thisYearData[0].organization_path,
        }));

        queryVariousStudentDataWithRegi(
          queryConditions,
          thisYearData[0].organization_path
        );
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.schoolYear, hrTeachersData]);

  function queryVariousStudentDataWithRegi(forWhere, organPath = "") {
    getVariousStudentDataWithRegi.mutate(forWhere, {
      onSuccess: (data) => {
        if (settingData) {
          const settingMap = settingData.reduce((map, setting) => {
            map[setting.id] = setting.group_name;
            return map;
          }, {});
          const updatedData = data.map((studentData) => {
            const pathParts = studentData.organization_path.split("/");
            const stageId = pathParts[2];
            const yearId = pathParts[3];
            const classId = pathParts[4];

            const groupNameOne = settingMap[stageId];
            const groupNameTwo = settingMap[yearId];
            const groupNameThree = settingMap[classId];

            return {
              ...studentData,
              hierarchyOne: groupNameOne,
              hierarchyTwo: groupNameTwo,
              hierarchyThree: groupNameThree,
            };
          });
          let filteredData = updatedData.filter((r) =>
            r.organization_path.startsWith(organPath)
          );
          setDataToSave(filteredData);
        }
      },
      onError: (error) => {
        console.error(error);
        alert(t("common.messages.errorAlert") + error.message);
      },
    });
  }

  useEffect(() => {
    if (filters.selectedStudent) {
      const studentData = dataToSave.find(
        (r) => r.username === filters.selectedStudent && r.group === "공통"
      );

      if (studentData && studentData.value_object) {
        const valueObj = studentData.value_object;
        const newRows = {
          1: {
            bookTitle: valueObj.bookTitle?.["1"] || "",
            author: valueObj.author?.["1"] || "",
            field: valueObj.field?.["1"] || "",
            bookTitleEng: valueObj.bookTitleEng?.["1"] || "",
          },
          2: {
            bookTitle: valueObj.bookTitle?.["2"] || "",
            author: valueObj.author?.["2"] || "",
            field: valueObj.field?.["2"] || "",
            bookTitleEng: valueObj.bookTitleEng?.["2"] || "",
          },
          3: {
            bookTitle: valueObj.bookTitle?.["3"] || "",
            author: valueObj.author?.["3"] || "",
            field: valueObj.field?.["3"] || "",
            bookTitleEng: valueObj.bookTitleEng?.["3"] || "",
          },
          4: {
            bookTitle: valueObj.bookTitle?.["4"] || "",
            author: valueObj.author?.["4"] || "",
            field: valueObj.field?.["4"] || "",
            bookTitleEng: valueObj.bookTitleEng?.["4"] || "",
          },
          5: {
            bookTitle: valueObj.bookTitle?.["5"] || "",
            author: valueObj.author?.["5"] || "",
            field: valueObj.field?.["5"] || "",
            bookTitleEng: valueObj.bookTitleEng?.["5"] || "",
          },
          total: {
            sumBooks: valueObj.total?.sumBooks ?? "",
            distance: valueObj.total?.distance ?? "",
            sumBooksEng: valueObj.total?.sumBooksEng ?? "",
            points: valueObj.total?.points ?? "",
          },
        };
        setReadingRows(newRows);
        setIsModified(false);
      } else {
        // 데이터가 없으면 초기화
        setReadingRows({
          1: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
          2: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
          3: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
          4: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
          5: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
          total: { sumBooks: "", distance: "", sumBooksEng: "", points: "" },
        });
        setIsModified(false);
      }
    } else {
      // 학생이 선택되지 않았으면 초기화
      setReadingRows({
        1: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        2: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        3: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        4: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        5: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        total: { sumBooks: "", distance: "", sumBooksEng: "", points: "" },
      });
      setIsModified(false);
    }
  }, [filters.selectedStudent, dataToSave]);

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    const selectedOptionText = e.target.selectedOptions[0].text;
    const dataName = e.target.selectedOptions[0].getAttribute("data-name");
    let organPath = "";
    if (!dataName) {
      organPath = "N/A";
    } else {
      organPath = dataName + "/" + value;
    }

    if (name === "0") {
      setFilters((filters) => ({
        ...filters,
        schoolYear: selectedOptionText,
        schoolYearId: value,
        hierarchyOneId: "",
        organPathForSort: "N/A",
        selectedStudent: "",
      }));
      setQueryConditions((prev) => ({
        ...prev,
        school_year_id: value,
        school_year: selectedOptionText,
      }));
      setDataToSave([]);
      setReadingRows({
        1: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        2: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        3: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        4: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        5: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        total: { sumBooks: "", distance: "", sumBooksEng: "", points: "" },
      });
    }

    if (name === "1") {
      setFilters((filters) => ({
        ...filters,
        hierarchyOneId: value,
        hierarchyTwoId: "",
        hierarchyThreeId: "",
        organPathForSort: "N/A",
        selectedStudent: "",
      }));
      setDataToSave([]);
      setReadingRows({
        1: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        2: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        3: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        4: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        5: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        total: { sumBooks: "", distance: "", sumBooksEng: "", points: "" },
      });
    }

    if (name === "2") {
      setFilters((filters) => ({
        ...filters,
        hierarchyTwoId: value,
        hierarchyThreeId: "",
        organPathForSort: "N/A",
        selectedStudent: "",
      }));
      setDataToSave([]);
      setReadingRows({
        1: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        2: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        3: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        4: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        5: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        total: { sumBooks: "", distance: "", sumBooksEng: "", points: "" },
      });
    }

    if (name === "3") {
      setFilters((filters) => ({
        ...filters,
        hierarchyThreeId: value,
        organPathForSort: organPath,
        selectedStudent: "",
      }));
      queryVariousStudentDataWithRegi(queryConditions, organPath);
      setReadingRows({
        1: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        2: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        3: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        4: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        5: { bookTitle: "", author: "", field: "", bookTitleEng: "" },
        total: { sumBooks: "", distance: "", sumBooksEng: "", points: "" },
      });
    }

    if (name === "students") {
      setFilters((filters) => ({
        ...filters,
        selectedStudent: value,
      }));
    }
  };

  const handleInputChange = (rowKey, field, value) => {
    setReadingRows((prev) => ({
      ...prev,
      [rowKey]: {
        ...prev[rowKey],
        [field]: value,
      },
    }));
    setIsModified(true);
  };

  const handleSave = (e) => {
    e.preventDefault();

    if (filters.selectedStudent === "") {
      handleToastCenterTop(t("common.messages.selectStudent"));
      setValidateInput((prev) => ({ ...prev, user: true }));
      return;
    } else {
      setValidateInput((prev) => ({ ...prev, user: false }));
    }

    if (
      !hasPermission(
        null,
        "can_create",
        checkHrteachers(
          hrTeachersData,
          filters.selectedStudent,
          filters.schoolYear
        )
      )
    ) {
      handleToastCenterTop(
        t("common.messages.homeroomTeacherOnly") ||
          "학생의 담임과 권한이 있는 사람만 저장할 수 있습니다."
      );
      return;
    }

    // 기존 데이터 찾기
    const existingData = dataToSave.find(
      (r) => r.username === filters.selectedStudent && r.group === "공통"
    );

    // value_object 구조 생성
    const valueObject = {
      bookTitle: {
        1: (readingRows[1].bookTitle || "").trim(),
        2: (readingRows[2].bookTitle || "").trim(),
        3: (readingRows[3].bookTitle || "").trim(),
        4: (readingRows[4].bookTitle || "").trim(),
        5: (readingRows[5].bookTitle || "").trim(),
      },
      author: {
        1: (readingRows[1].author || "").trim(),
        2: (readingRows[2].author || "").trim(),
        3: (readingRows[3].author || "").trim(),
        4: (readingRows[4].author || "").trim(),
        5: (readingRows[5].author || "").trim(),
      },
      field: {
        1: (readingRows[1].field || "").trim(),
        2: (readingRows[2].field || "").trim(),
        3: (readingRows[3].field || "").trim(),
        4: (readingRows[4].field || "").trim(),
        5: (readingRows[5].field || "").trim(),
      },
      bookTitleEng: {
        1: (readingRows[1].bookTitleEng || "").trim(),
        2: (readingRows[2].bookTitleEng || "").trim(),
        3: (readingRows[3].bookTitleEng || "").trim(),
        4: (readingRows[4].bookTitleEng || "").trim(),
        5: (readingRows[5].bookTitleEng || "").trim(),
      },
      total: {
        sumBooks: (readingRows.total.sumBooks || "").trim(),
        distance: (readingRows.total.distance || "").trim(),
        sumBooksEng: (readingRows.total.sumBooksEng || "").trim(),
        points: (readingRows.total.points || "").trim(),
      },
    };

    const saveData = {
      id: existingData?.id, // 기존 데이터가 있으면 id 포함 (update), 없으면 undefined (create)
      schoolid: schoolId,
      school_year_id: filters.schoolYearId,
      record_list_id: inputQueryConditions?.record_list_id,
      group: "공통",
      username: filters.selectedStudent,
      value_object: valueObject,
      allow_duplicate: false,
    };

    setIsLoadingModal(true);

    createOrUpdateVariousStudentRecords.mutate(saveData, {
      onSuccess: (successMessage) => {
        setIsLoadingModal(false);
        setIsModified(false);
        handleToastCenterTop(
          t("common.messages.savedSuccessfully") || "저장되었습니다."
        );
        queryVariousStudentDataWithRegi(
          queryConditions,
          filters.organPathForSort
        );
      },
      onError: (error) => {
        setIsLoadingModal(false);
        console.error(error);
        alert(t("common.messages.errorAlert") + error.message);
      },
    });
  };

  return (
    <>
      <div className="row mt-3">
        <div className="col-auto">
          <h3 className="fw-bold">
            {t("teacher.schoolLifeRecords.readingRecord")}
            <HelpHyperLink link={"https://youtu.be/zqPZn5vI4EE"} />
          </h3>
        </div>
        <div className="col">
          <DropdownSchoolYear
            settingData={settingData}
            handleDropdownChange={handleDropdownChange}
            schoolYearId={filters.schoolYearId}
            allYears={false}
          />
        </div>
        <div className="col">
          <DropdownHierarchyOne
            settingData={settingData}
            handleDropdownChange={handleDropdownChange}
            schoolYear={filters.schoolYear}
            hierarchyOneId={filters.hierarchyOneId}
          />
        </div>
        <div className="col">
          <DropdownHierarchyTwo
            settingData={settingData}
            handleDropdownChange={handleDropdownChange}
            schoolYear={filters.schoolYear}
            hierarchyOneId={filters.hierarchyOneId}
            hierarchyTwoId={filters.hierarchyTwoId}
          />
        </div>
        <div className="col">
          <DropdownHierarchyThree
            settingData={settingData}
            handleDropdownChange={handleDropdownChange}
            schoolYear={filters.schoolYear}
            hierarchyTwoId={filters.hierarchyTwoId}
            hierarchyThreeId={filters.hierarchyThreeId}
          />
        </div>
        <div className="col">
          <DropdownUniqueUsersInDisplayData
            displayData={studentList}
            displayKey={"fullname"}
            valueKey={"username"}
            filters={{ organization_path: filters.organPathForSort }}
            uniqueKey={"username"}
            sortKey={"studentno"}
            isDesc={false}
            handleDropdownChange={handleDropdownChange}
            selectedUser={filters.selectedStudent}
            selectName={"students"}
            styleClass={"form-control"}
            dropdownTitle={t("common.user.student") || "학생"}
            required={true}
            highLight={validateInput?.user}
          />
          <input
            readOnly
            type="text"
            className="input-like-span p-1"
            value={filters.selectedStudent || ""}
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <h6>아래에 입력하여 독서활동기록을 저장 할 수 있습니다.</h6>
        </div>
      </div>

      <div className="row mt-3">
        {filters.selectedStudent &&
        !hasPermission(
          null,
          "can_read",
          checkHrteachers(
            hrTeachersData,
            filters.selectedStudent,
            filters.schoolYear
          )
        ) ? (
          <SimpleAlertMessageBlock
            message={t("common.messages.homeroomAccessOnly")}
          />
        ) : (
          <div className="col" style={{ minWidth: "800px", overflowX: "auto" }}>
            <table className="table table-hover table-bordered table-sm">
              <colgroup>
                <col width="9%" />
                <col width="30%" />
                <col width="18%" />
                <col width="12%" />
                <col width="15%" />
                <col width="16%" />
              </colgroup>
              <thead
                className="text-center"
                style={{ backgroundColor: "#e9ecef" }}
              >
                <tr>
                  <th
                    scope="col"
                    rowSpan="2"
                    className="align-middle"
                    style={{ backgroundColor: "#e9ecef" }}
                  >
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={handleSave}
                      disabled={!isModified}
                    >
                      저장
                    </button>
                  </th>
                  <th
                    scope="col"
                    colSpan="3"
                    style={{ backgroundColor: "#e9ecef" }}
                  >
                    Reading Race
                  </th>
                  <th
                    scope="col"
                    colSpan="2"
                    style={{ backgroundColor: "#e9ecef" }}
                  >
                    Reading Gate
                  </th>
                </tr>
                <tr>
                  <th scope="col" style={{ backgroundColor: "#e9ecef" }}>
                    책 제목
                  </th>
                  <th scope="col" style={{ backgroundColor: "#e9ecef" }}>
                    지은이
                  </th>
                  <th scope="col" style={{ backgroundColor: "#e9ecef" }}>
                    영역
                  </th>
                  <th
                    scope="col"
                    colSpan="2"
                    style={{ backgroundColor: "#e9ecef" }}
                  >
                    Book Title
                  </th>
                </tr>
              </thead>
              <tbody>
                {[1, 2, 3, 4, 5].map((num) => (
                  <tr key={num}>
                    <td className="text-center">{num}</td>
                    <td
                      className="text-center"
                      style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                    >
                      <textarea
                        className="form-control"
                        value={readingRows[num].bookTitle}
                        onChange={(e) =>
                          handleInputChange(num, "bookTitle", e.target.value)
                        }
                      />
                    </td>
                    <td
                      className="text-center"
                      style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                    >
                      <textarea
                        className="form-control"
                        value={readingRows[num].author}
                        onChange={(e) =>
                          handleInputChange(num, "author", e.target.value)
                        }
                      />
                    </td>
                    <td
                      className="text-center"
                      style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                    >
                      <textarea
                        className="form-control"
                        value={readingRows[num].field}
                        onChange={(e) =>
                          handleInputChange(num, "field", e.target.value)
                        }
                      />
                    </td>
                    <td
                      colSpan="2"
                      className="text-center"
                      style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                    >
                      <textarea
                        className="form-control"
                        value={readingRows[num].bookTitleEng}
                        onChange={(e) =>
                          handleInputChange(num, "bookTitleEng", e.target.value)
                        }
                      />
                    </td>
                  </tr>
                ))}
                <tr>
                  <td className="text-center">...</td>
                  <td className="text-center">...</td>
                  <td colSpan="2" className="text-center">
                    ...
                  </td>
                  <td colSpan="2" className="text-center">
                    ...
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td className="text-center">합계</td>
                  <td
                    className="text-center"
                    style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                  >
                    <input
                      type="number"
                      className="form-control"
                      style={{
                        width: "70%",
                        display: "inline-block",
                        fontSize: "smaller",
                      }}
                      value={readingRows.total.sumBooks}
                      onChange={(e) =>
                        handleInputChange("total", "sumBooks", e.target.value)
                      }
                    />{" "}
                    권
                  </td>
                  <td
                    colSpan="2"
                    className="text-center"
                    style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                  >
                    <input
                      type="number"
                      className="form-control"
                      style={{
                        width: "70%",
                        display: "inline-block",
                        fontSize: "smaller",
                      }}
                      value={readingRows.total.distance}
                      onChange={(e) =>
                        handleInputChange("total", "distance", e.target.value)
                      }
                    />{" "}
                    km
                  </td>
                  <td
                    className="text-center"
                    style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                  >
                    <input
                      type="number"
                      className="form-control"
                      style={{
                        width: "70%",
                        display: "inline-block",
                        fontSize: "smaller",
                      }}
                      value={readingRows.total.sumBooksEng}
                      onChange={(e) =>
                        handleInputChange(
                          "total",
                          "sumBooksEng",
                          e.target.value
                        )
                      }
                    />{" "}
                    권
                  </td>
                  <td
                    className="text-center"
                    style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                  >
                    <input
                      type="number"
                      className="form-control"
                      style={{
                        width: "65%",
                        display: "inline-block",
                        fontSize: "smaller",
                      }}
                      value={readingRows.total.points}
                      onChange={(e) =>
                        handleInputChange("total", "points", e.target.value)
                      }
                    />{" "}
                    point
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
